module.exports = (type, classNameForNode = '', html = '') => {
    const node = document.createElement(type);
    node.innerHTML = html;

    if (classNameForNode !== '') {
        node.className = classNameForNode;
    }

    return node;
};
